module.exports = __webpack_public_path__ + "media/images/athletes/550-d3695471bb2d6b30c22e61977f44fe00.png";